const ACTIVE_CLASS = 'active';
const OFFSET_ATT = 'data-anchors-offset';

function process(offset)
{
    let anchors = getAnchors();
    let viewPortBottom = window.innerHeight;

    anchors.forEach(i => {
        let tmpElement = document.querySelector(i);

        if(tmpElement) {
            let tmpTarget = tmpElement.parentElement.parentElement;

            if(isInViewPort(tmpTarget.getBoundingClientRect(), viewPortBottom, offset)) {
                document.querySelector('a[href="'+i+'"]').classList.add(ACTIVE_CLASS);
                return true;
            }
        }

        return false;
    });
}

function isInViewPort(clientRect, viewPortBottom, offset)
{
    viewPortBottom -= offset;

    if(clientRect.top > 0 && clientRect.top < viewPortBottom) {
        return true;
    }

    return clientRect.top < 0 && clientRect.bottom > offset;

}

function getAnchors()
{
    let anchors = [];

    document.querySelectorAll('[data-active-anchors]>a[href^="#"]').forEach(anchor => {
        let href = anchor.getAttribute('href');

        if(href.length > 1) {
            anchor.classList.remove(ACTIVE_CLASS);
            anchors.push(href);
        }
    });

    return anchors;
}

export function run()
{
    let offsetEl = document.querySelector('['+OFFSET_ATT+']');
    let offset = offsetEl ? offsetEl.getAttribute(OFFSET_ATT) : 100;

    window.addEventListener('scroll', () => {
        process(offset);
    });
}
